module.exports = __webpack_public_path__ + "img/icon5-1(3).6e6f373a.png";